import { useMutation } from "@tanstack/react-query";
import { getNodesForLessonProgress } from "@api/services/node-service";
import { generateMyNodeReport } from "helpers/myNodeReport";
import { useAuthContext } from "@hooks/useAuthContext";
import { useContext } from "react";
import { MyTrainingsViewContext } from "@context/myTrainings/MyTrainingsViewContext";
import { VrLessonProgress } from "@models/LessonProgress";
import { IGetNodeForLessonProgressRequest } from "@api/models/request/IGetNodesForLessonProgressRequest";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { handleApiError } from "helpers/handleApiError";

export const useDownloadMyNodeReport = () => {
  const { userState } = useAuthContext();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { user, isStatisticOfLoggedUser } = useContext(MyTrainingsViewContext);
  const targetUserId = isStatisticOfLoggedUser ? undefined : user?.id;

  const mutation = useMutation({
    mutationFn: async (lp: VrLessonProgress) => {
      const request: IGetNodeForLessonProgressRequest & {
        workspaceId: string;
      } = {
        lessonProgressId: lp.id,
        userId: targetUserId,
        workspaceId: userState.user.selectedWorkspace.workspaceId
      };
      const response = await getNodesForLessonProgress(request);
      if (!response.success || !response.data)
        throw new Error(response.message ?? "error");
      return response.data;
    },
    onSuccess: (data, lp) => {
      generateMyNodeReport({
        lp,
        user: {
          displayName: user?.displayName ?? "",
          tagA: user?.tagA,
          tagB: user?.tagB,
        },
        nodes: data.nodes,
        completedNodes: lp.completedNodes,
        feedback: data.feedback,
        reward: data.reward,
        t,
      });
    },
    onError: (error) => {
      handleApiError(error, { t, enqueueSnackbar });
    },
  });

  return { downloadReport: mutation.mutate, isReportLoading: mutation.isPending};
};